import {
  collection,
  addDoc,
  serverTimestamp
} from "firebase/firestore";

import { db } from "../app/Config/firebase";
import { aplicarTenantAtual } from "../app/Utils/tenant";

const colRef = collection(db, "kpi_respostas");

export async function salvarRespostaKPI(data) {
  return await addDoc(colRef, aplicarTenantAtual({
    ...data,
    createdAt: serverTimestamp()
  }));
}
